import React from 'react';

import classes from './ResumeCompleteness.module.scss';

const ResumeCompleteness = ({ percent = 0 }) => {
    return (
        <div className={`${classes['resume-completeness']}`}>
            <h3>Resume Completeness</h3>
            <p>Complete your resume to increase your chances of being seen and finding better job opportunities.</p>
            <div className={`${classes['resume-progress']} d-flex flex-row gap-1 align-items-center`}>
                <div className={`${classes['resume-progress-bar']}`}>
                    <div style={{ width: `${percent}%` }}></div>
                </div>
                <p>{`${percent}%`}</p>
            </div>
        </div>
    );
};

export default ResumeCompleteness;